import React, { useState } from 'react';
import { useGetResourcesHeadersQuery, useDeleteResourceHeaderMutation, useUpdateResourceHeaderMutation, useCreateResourceHeaderMutation} from '../../../../services/resourcesApi';
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNotification } from '../../../../context/NotificationContext';
import { createErrorMessage } from '../../../../utils';
import ResourceHeaderCard from './ResourceHeaderCard';
import ResourceHeaderEdit from './ResourceHeaderEdit';
import ResourceHeaderCreate from './ResourceHeaderCreate';
import {Button} from '@mui/material';
import ResourceHeaderOrderModal from './ResourceHeaderOrderModal';

const accordionStyles = {
  "& .MuiTypography-root": {
    fontSize: "20px",
    // otros estilos de texto
  },
  "& .MuiExpansionPanel": {
    root: {
      "&:before": {
        display: "none",
      },
      // otros estilos de acordeón
    },
  },
};

const buttonStyles = {
  color: "var(--orange)",
  margin: "0 1rem",
};

function ResourceHeaderPanel() {

  const { showNotification } = useNotification();

  const { data, error, isLoading } = useGetResourcesHeadersQuery();
  const [deleteResourceHeader] = useDeleteResourceHeaderMutation();
  const [updateResourceHeader] = useUpdateResourceHeaderMutation();
  const [createResourceHeader] = useCreateResourceHeaderMutation();
  const [loadingStates, setLoadingStates] = useState({});
  const [editingResource, setEditingResource] = useState(null);
  const [orderModalOpen, setOrderModalOpen] = useState(false);

  const handleDeleteClick = async (resourceId) => {
    setLoadingStates({ ...loadingStates, [resourceId]: true });
    try {
      await deleteResourceHeader(resourceId).unwrap();
    } catch (error) {
      console.log("error: " , error);
      showNotification(createErrorMessage(error), 'error');
    }
    setLoadingStates({ ...loadingStates, [resourceId]: false });
  };

  const handleEditClick = (resource) => {
    setEditingResource(resource.id);
  };

  const handleSaveEdit = async(editedResource) => {
    try {
      await updateResourceHeader(editedResource).unwrap();
      showNotification('Resource Header updated successfully', 'success');
    } catch (error) {
      console.log("error: " , error);
      showNotification(createErrorMessage(error), 'error');
    }
    setEditingResource(null);
  };

  if (error) {
    return <div>Something went wrong</div>;
  }

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const handleSaveCreation = async (newResource) => {
    try {
      await createResourceHeader(newResource).unwrap();
      showNotification('Resource Header created successfully', 'success');
    } catch (error) {
      console.log("error: " , error);
      showNotification(createErrorMessage(error), 'error');
    }
  }

  return (
    <>
    <ResourceHeaderCreate onResourceCreated={(newResource)=> handleSaveCreation(newResource)} />
      <Accordion sx={accordionStyles} elevation={0}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={buttonStyles} />}
            sx={{ "& .MuiButtonBase-root.MuiAccordionSummary-root": { flexGrow: 0, justifyContent: "flex-start" } }}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <h4>Resources Headers</h4>
          </AccordionSummary>
            <Button onClick={()=> setOrderModalOpen(true)}>Order List</Button>
        </div>
        <AccordionDetails>
        <Grid container xs={12} direction="row" justifyContent="flex-start" alignItems="center" spacing={2} >
          {data.map((resource) => {
            return (
              <Grid item xs="auto" key={resource.id} >
                {editingResource === resource.id ? (
                  <ResourceHeaderEdit resource={resource} onSaveEdit={handleSaveEdit} onCancelEdit={() => setEditingResource(null)}/>
                ) : (
                  <ResourceHeaderCard
                    resource={resource}
                    onEditClick={() => handleEditClick(resource)}
                    onDeleteClick={() => handleDeleteClick(resource.id)}
                    isLoading={loadingStates[resource.id]}
                  />
                )}
              </Grid>
            );
          })
          }
          </Grid>
        </AccordionDetails>
      </Accordion>

      <ResourceHeaderOrderModal open={orderModalOpen} handleClose={ ()=> setOrderModalOpen(false) }/>
    </>
  );
}

export default ResourceHeaderPanel;
